// textToSpeech.js
import axios from "axios";

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_CLOUD_API_KEY2;

export async function textToSpeech(rawInput, voice = "en-US-Standard-C") {
  let payload = rawInput.trim().startsWith("<")
    ? rawInput
    : `<speak>${rawInput}</speak>`;
  const inputField = { ssml: payload };
  const requestBody = {
    input: inputField,                                     // <-- key change
    voice: { languageCode: "en-US", name: voice },
    audioConfig: { audioEncoding: "MP3" },
  };

  const url = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${GOOGLE_API_KEY}`;

  try {
    const { data } = await axios.post(url, requestBody);
    return data.audioContent;
  } catch (error) {
    // If the server responded with an error payload, log it:
    if (error.response) {
      console.error("[TTS] HTTP", error.response.status, error.response.statusText);
      console.error("[TTS] Response data:", error.response.data);
    } else {
      // Network / client‐side error
      console.error("[TTS] Request error:", error.message);
    }

    // Throw a descriptive error so callers can react
    const errMsg = error.response?.data?.error?.message 
      ? error.response.data.error.message 
      : error.message;
    throw new Error(`TextToSpeech failed: ${errMsg}`);
  }
}

export default textToSpeech;
